import EnvConfig from '../services/config/envConfig';

export default function openPrivacyPolicy() {
  window.open(EnvConfig.getPrivacyPolicyUrl());
}
